import PathConstants from "./path-constants";

export const appealsFlowRoutes = [
  PathConstants.AppealDepartment,
  PathConstants.EmployerAddress,
  PathConstants.UploadInsuranceCard,
  PathConstants.LetsGetStarted,
  PathConstants.UploadProcessing,
  PathConstants.ConfirmInsuranceDetails,
  PathConstants.PrimaryEnrollee,
  PathConstants.DenyingPartyPage,
  PathConstants.ExperienceSummary,
  PathConstants.LetterBuildingInterstitial,
  PathConstants.AppealOverview,
  PathConstants.PreviewComplete,
  PathConstants.PreviewAndReviewAppealLetter,
  PathConstants.AttachDoctorStatement,
  PathConstants.PatientData,
  PathConstants.PrePayment,
];
